import type { UserProps } from '../TicketConversation.types';
import {
    Link,
    mergeStyleSets
} from '@fluentui/react';
import { ProviderConsumer } from '@fluentui/react-northstar';
import { themeNames } from '@fluentui/react-teams';
import React, { useEffect, useState } from 'react';
import { UserForm } from '../../../../user/UserForm';
import { UserPanel } from '../../../../user/UserPanel';
import { getCachedUser } from '../../../cache/PlatformUserCache';
import { useTranslation } from 'react-i18next';

const UserInfoLink: React.FC<{ user: UserProps; isEndUserPage?: boolean }> = (props: { user: UserProps; isEndUserPage?: boolean }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isError, setIsError] = useState(false);
    const [platformUser, setPlatformUser] = useState<PlatformUser>(null);
    const [isLoading, setIsLoading] = useState(true);

    const { t } = useTranslation();
    const setOpen = (): void => {
        setIsOpen(true);
    };

    const getErrorText = () => {
        return t('ticket-details.ticket-conversation.user-info-link-error', { name: props.user.Name || "" })
    }

    const classNames = mergeStyleSets({
        userLink: {
            paddingTop: '10px',
            color: 'var(--mgt-theme-brand-foreground1)',
            ':hover, :active, :focus': {
                color: 'var(--mgt-theme-brand-foreground1) !important'
            }
        },
    });

    useEffect(() => {
        const fetchUser = async () => {
            try {
                let user = await getCachedUser(props.user.Id);
                setPlatformUser(user);
            } catch {
                setIsError(true);
            }
            setIsLoading(false);
        };

        fetchUser();
    }, [props.user.Id]);

    const getUserId = (): string => {
        if (!platformUser && !props.user) {
            setIsError(true);
            return '';
        }

        const user: PlatformUser | UserProps = platformUser || props.user;

        if (isNaN(user.Id)) {
            setIsError(true);
            return '';
        }

        return user.Id.toString();
    }

    if (!platformUser && !isLoading)
        return <b>{t('ticket.ticket-board.ticket-card.unassigned')}</b>;

    return (
        <ProviderConsumer render={(globalTheme) => (
            <>
                {!(props.isEndUserPage ?? false) && (<>
                    <Link className={`${classNames.userLink} font-bold`} onClick={setOpen}>{platformUser?.FullName ?? platformUser?.UserName ?? props.user.Name}</Link>
                    <UserPanel
                        isOpen={isOpen}
                        onDismiss={() => setIsOpen(false)}
                        className={globalTheme.siteVariables.theme === themeNames.Default ? "" : "panel--darkmode"}
                    >
                        {isError ? (
                            <div dangerouslySetInnerHTML={{ __html: getErrorText() }}></div>
                        ) : (
                            <UserForm
                                isUserInfoOnly={true}
                                id={getUserId()}
                                onClose={() => setIsOpen(false)}
                            />
                        )}
                    </UserPanel>
                </>)}
                {(props.isEndUserPage ?? false) && (<span><strong>{platformUser?.FullName ?? platformUser?.UserName ?? props.user.Name}</strong></span>)}
            </>
        )} />
    );
};

export default UserInfoLink;